import { Routes } from '@angular/router'
import { UserComponent } from './components/user.component'

import { UserManagementLayoutComponent } from './components/layout/user-management-layout.component'
import { PasswordResetComponent } from './components/password-reset/password-reset.component'
import { UpdatePasswordComponent } from './components/update-password/update-password.component'
import { UpdateEmailComponent } from './components/update-email/update-email.component'
import { UpdateCellphonenoComponent } from './components/update-CellPhoneNo/update-cellphoneno.component'
import { UserTrainingDetailsComponent } from './components/user-training-details/user-training-details-component'
import { LicenseApptComponent } from './components/license-appt/license-appt.component'
import { UserListComponent } from './components/user-list/user-list.component'
import { TrainingReviewComponent } from "./components/training-review/training-review.component"
import { IsSuperAdminOrGuruAdminGuard } from "../auth/is-super-admin-or-guru-admin-guard"
import { IsAdminGuard } from '../auth/is-admin-guard'
import { LicenseLoginComponent } from './components/license-after-login/license-component'
import { UploadAppointmentsComponents } from "././components/Upload-Appointments/Upload-Appointments.component"
import { UserSearchComponent } from "././components/user-search/user-search.component"
import { UserSearchDetailComponent } from "././components/user-search/user-details.component"
import { NEJEAddProfileComponent } from './components/neje/add-profile/add-profile.component'

import { UserListVerOneComponent } from './components/user-list/user-list-ver-one.component';
import { CanActivateGaurd } from '../auth/can-activate-gaurd'
import { SendAuthcodeComponent } from './components/mfa/send-authcode/send-authcode.component'

export const routes: Routes = [
    {

        path: '',
        component: UserManagementLayoutComponent, 
        children: [

            {
                path: 'user',
                canActivate: [CanActivateGaurd],
                component: UserComponent
            },
            {
                path: 'edit-user/:mode/:userprofileid',
                canActivate: [CanActivateGaurd],
                component: UserComponent
            },
            //{
            //    path: 'edit-user/:mode/:userprofileid/:iscontract',
            //    component: UserComponent
            //},
            {
                path: 'edit-user/:mode/:userprofileid/:isfromUserSearch',
                canActivate: [CanActivateGaurd],
                component: UserComponent
            },
            {
                path: 'edit-user/:mode',
                canActivate: [CanActivateGaurd],
                component: UserComponent
            },
            {
                path: 'reset/:userprofileid',
                canActivate: [CanActivateGaurd],
                component: PasswordResetComponent
            },
            {
                path: 'update/:userprofileid',
                canActivate: [CanActivateGaurd],
                component: UpdatePasswordComponent
            },
            {
                path: 'ChangeEmail/:userprofileid/:isChangeCellPhoneNumber',
                canActivate: [CanActivateGaurd],
                component: UpdateEmailComponent
            },
            {
                path: 'ChangeCellPhoneNo/:userprofileid',
                canActivate: [CanActivateGaurd],
                component: UpdateCellphonenoComponent
            },
            {
                path: 'update/:userprofileid/:ispasswordchange/:isChangeEmail/:isChangeCellPhoneNumber',
                canActivate: [CanActivateGaurd],
                component: UpdatePasswordComponent
            },
            {
                path: 'training',
                canActivate: [CanActivateGaurd],
                component: UserTrainingDetailsComponent
            },
            {
                path: 'license',
                canActivate: [CanActivateGaurd],
                component: LicenseApptComponent
            },
            {
                path: 'user-list',
                canActivate: [CanActivateGaurd],
                component: UserListComponent
            },
            //{
            //    path: 'user-list-v1',
            //    component: UserListVerOneComponent
            //},
            {
                path: 'user-list/:isUserSearched',
                canActivate: [CanActivateGaurd],
                component: UserListComponent
            },
            {
                path: 'user-search',
                canActivate: [CanActivateGaurd],
                component: UserSearchComponent
            },
            {
                path: 'user-search/:userProfileID',
                canActivate: [CanActivateGaurd],
                component: UserSearchDetailComponent
            },
            //{
            //    path: 'licenselogin/:userprofileid',
            //    component: LicenseLoginComponent
            //},
            {
                path: 'my-profile/:userProfileID/:view',
                canActivate: [CanActivateGaurd],
                component: UserSearchDetailComponent
            },
            {
                path: 'view-profile/:userProfileID/:Editview',
                canActivate: [CanActivateGaurd],
                component: UserSearchDetailComponent
            },
            {
                path: 'training-review',
                canActivate: [CanActivateGaurd],
                component: TrainingReviewComponent,
             //  canActivate: [IsSuperAdminOrGuruAdminGuard]
            },
            {
                path: 'licenselogin/:userprofileid',
                canActivate: [CanActivateGaurd],
                component: LicenseLoginComponent
            },
            {
                path: 'UploadAppointments',
                canActivate: [CanActivateGaurd],
                component: UploadAppointmentsComponents
            },
            {
                path: 'neje/add-profile/:mode',
                canActivate: [CanActivateGaurd],
                component: NEJEAddProfileComponent
            },
            {
                path: 'neje/add-profile/:mode/:userprofileid',
                canActivate: [CanActivateGaurd],
                component: NEJEAddProfileComponent
            },
            {
                path: 'neje/add-profile/:mode/:userprofileid/:isfromUserSearch',
                canActivate: [CanActivateGaurd],
                component: NEJEAddProfileComponent
            },
            {
                path: 'sendmfacode',
                //canActivate: [CanActivateGaurd],
                //loadComponent: () => import('./components/mfa/send-authcode/send-authcode.component').then(m => m.SendAuthcodeComponent)
                component: SendAuthcodeComponent
            }
        ]

    }
]
